import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
    selector: 'build-detail',
    template: require('./detail.html')
})
export class BuildDetailComponent implements OnInit {
    activeTab: string;

    @Input() project: any = null;
    @Input() build: any = null;
    @Input() projectMenu: any = null;

    constructor(
        private stateService: StateService, 
    ) { }
    
    ngOnInit() { }

}